document.addEventListener('DOMContentLoaded', function () {
  if (localStorage.getItem('wizzyIsRedirectedFlag') === "true" && window.location.pathname == '/collections/best-seller') {
    const wrapper = document.querySelector('.collection__wrapper .wrapper--full-padded');

    if (wrapper) {
      const message = document.createElement('h3');
      message.textContent = 'The product you are searching for is not available';

      wrapper.insertBefore(message, wrapper.firstChild);
    }
  }
});

const changeTemplate = function (div) {
  const oldDiv = document.getElementById(div);
  const newDiv = document.getElementById(div + "-new").text;
  oldDiv.text = newDiv;
};

const addSizeSorting = (filter, isFilter) => {
  let isJson = false;
  let isSortJson = false;
  if (typeof filter == "string") {
    isJson = true;
    filter = JSON.parse(filter);
  }
  if (typeof filter.sort == "string") {
    isSortJson = true;
    filter.sort = JSON.parse(filter.sort);
  }
  let newSort = [];
  //when sort is relevance than update sort as per requierment
  if (filter.sort[0].field === "relevance") {
    // if (!isFilter) {
    //   newSort.push({
    //     field: "product_value_tags_single_type_ruled_based_bt:float",
    //     order: "desc",
    //     // order: "asc",
    //   });
    // }
    filter.sort.forEach((x) => {
      if (x.field != "product_value_tags_single_type_ruled_based_bt:float") {
        newSort.push(x);
      }
    });
  } else {
    //else make sure that selected sort is applying
    newSort = filter.sort;
  }
  if (isFilter) {
    newSort.push({
      field: "product_value_tags_single_type_ruled_based_bt:float",
      order: "desc",
      // order: "asc",
    });
  }
  filter.sort = newSort;
  if (isSortJson) {
    filter.sort = JSON.stringify(filter.sort);
  }
  if (isJson) {
    filter = JSON.stringify(filter);
  }
};

window.onWizzyScriptLoaded = function () {
  changeTemplate("wizzy-search-results-product");
  changeTemplate("wizzy-autocomplete-topproducts");
  changeTemplate("wizzy-search-empty-results");

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      data.search.configs.facets.leftFacets.mobileCollapsible = true;
      data["filters"]["configs"]["keepOpenedInMobileAfterApply"] = true;
      window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
        {
          dom: "wizzy-search-input",
          type: "text",
        },
        {
          dom: "header input",
          type: "search",
        },
      ];
      window.wizzyConfig["search"]["configs"]["pagination"][
        "infiniteScrollOffset"
      ] = { desktop: 3000, mobile: 2000 };
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (filter) {
      return (
        filter.sort ||
          (filter.sort = [
            {
              field: "relevance",
              order: "asc",
            },
          ]),
        // addSizeSorting(filter, false),
        filter
      );
    }
  );

  let clicked_on = "NA";
    $(document).on('mousedown', '.autocomplete-item a', function () {
      const $item = $(this).closest('.autocomplete-item');
      const $head = $item.prevAll('.autocomplete-item-head').first();

      if ($head.length) {
        const sectionTitle = $head.text().trim();

        if (sectionTitle === 'Categories') {
          clicked_on = 'categories';
        } else if (sectionTitle === 'Trending Searches') {
          clicked_on = 'trending_searches';
        }
      }
    });

  $(document).on('mousedown', '.autocomplete-top-products .topproduct-item', function () {
      let event = "search_term_entered";

      let section_name = "top_products";
      let selection_type = "suggested_search_term";

      let productName = $(this).find('.product-grid-item__title').text().trim();
      let search_term = productName;

      let cta_text = productName;

      
      const eventData = {
        event: 'search_term_entered',
        section_name,
        search_term,
        selection_type,
        cta_text
      };

      if (!window.dataLayer) window.dataLayer = [];
      
      const index = window.dataLayer.findIndex(e => e.event === 'search_term_entered');
      
      if (index > -1) {
        Object.assign(window.dataLayer[index], eventData);
      } else {
        window.dataLayer.push(eventData);
      }
      
    });

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {

      let autocomplete = document.querySelector('.wizzy-autocomplete-wrapper');
      let event = "search_term_entered";

      section_name = clicked_on;

      let selection_type;
      if(clicked_on != "NA")
      {
        selection_type = "suggested_search_term";
      }
      else
      {
        selection_type = "manual";
      }

      search_term = data.q;

      cta_text = data.q;

      const eventData = {
        event: 'search_term_entered',
        search_term,
        section_name,
        selection_type,
        cta_text
      };
      if (!window.dataLayer) window.dataLayer = [];
      window.dataLayer.push(eventData);

      
      var closeButton = document.querySelector(".search-bar-close__button");
      if (closeButton) {
        closeButton.click();
      }


data.sort = [
  {
    field: "product_wizzy-best-selling_sortOrder:float",
    order: "asc"
  },
  {
    field: "relevance",
    order: "asc"
  }
];

console.log("updated sort", data.sort);



      // addSizeSorting(data, false);
      if (localStorage.getItem('wizzyIsRedirectedFlag') === "true") {
        window.location.replace("https://nashermiles.com/collections/best-seller");
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      clicked_on = "NA";
      return data;
    });

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {
      setTimeout(function () {
        var autoCompleteWrapper = document.querySelector(
          ".wizzy-autocomplete-wrapper.onLeft"
        );
        // console.log("WIZ autocom", autoCompleteWrapper);
        if (autoCompleteWrapper) {
          var predictiveSearch = document.querySelector("#searchInput-desktop");
          if (predictiveSearch) {
            var positionInfo = predictiveSearch.getBoundingClientRect();
            var left = positionInfo.left;
            var top = positionInfo.top + positionInfo.height;
            console.log("WIZ autocom values", top, left);
            autoCompleteWrapper.style.setProperty("top", top + "px");
            autoCompleteWrapper.style.setProperty(
              "right",
              left + "px",
              "important"
            );
          }
        }
      }, 200);
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
    function (data) {
      localStorage.setItem("wizzyIsRedirectedFlag", false);
      let x = document.querySelector(".wizzy-body-end-wrapper");
      if (
        x &&
        typeof data.isForDefault !== "undefined" &&
        data.isForDefault === true
      ) {
        x.classList.add("wizzy-view-more-hide");
      } else if (x && x.classList.contains("wizzy-view-more-hide")) {
        x.classList.remove("wizzy-view-more-hide");
      }
      if (data?.payload?.products?.result.length == 0) {
        localStorage.setItem("wizzyIsRedirectedFlag", true);
      } else {
        localStorage.setItem("wizzyIsRedirectedFlag", false);
      }
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      console.log("Before data", data);
      if (data.group === "defaultMenu" && data.filters && data.filters.sort) {
        data.filters.sort = [
          {
            field: "product_top-products_sortOrder:float",
            order: "asc",
          },
        ];
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      data?.forEach((product) => {
        product.indiTags = "";
        product?.attributes?.forEach((attribute) => {
          if (attribute.id === "product_indi_tags") {
            if (attribute.values.length > 0) {
              product.indiTags = attribute.values[0].value[0];
            }
          }
        });
      });

      data?.forEach((product) => {
        product.ratingPresent = false;
        product?.attributes?.forEach((attribute) => {
          if (attribute.id === "product_reviews_average_opinew_metafields") {
            if (attribute.values.length > 0) {
              product.avgRatings = attribute?.values[0].value[0];
              if (parseFloat(product.avgRatings) > 0) {
                product.ratingPresent = true;
              }
            }
          }
          if (attribute.id === "product_reviews_count_opinew_metafields") {
            if (attribute.values.length > 0) {
              product.totalReviews = attribute?.values[0].value[0];
            }
          }
        });
      });

      data?.forEach((product) => {
        product.newArrival = false;
        product.bestSeller = false;
        product.backInStock = false;
        product.attributes.forEach((attribute) => {
          if (attribute.id === "product_tags") {
            attribute?.values?.forEach((tag) => {
              if (tag.value.some((value) => value.includes("tag__newlaunch"))) {
                product.newArrival = true;
              }
            });
            attribute?.values?.forEach((tag) => {
              if (
                tag.value.some((value) => value.includes("tag__Bestseller"))
              ) {
                product.bestSeller = true;
              }
            });
            attribute?.values?.forEach((tag) => {
              if (
                tag.value.some((value) => value.includes("tag__backinstock"))
              ) {
                product.backInStock = true;
              }
            });
          }
        });
      });

      data?.forEach((product) => {
        function removeLastThreeIfDotZero(str) {
          if (str.endsWith(".00")) {
            return str.substring(0, str.length - 3);
          }
          return str;
        }
        if (product.sellingPrice) {
          product.sellingPrice = removeLastThreeIfDotZero(product.sellingPrice);
        }
        if (product.price) {
          product.price = removeLastThreeIfDotZero(product.price);
        }
      });

      data?.forEach((product) => {
        product.ratingValue = 0;
        if (product.avgRatings) {
          const rating = parseFloat(product.avgRatings);
          if (!isNaN(rating)) {
            var result = 5 - rating;
            product.ratingValue = result * 20;
            // console.log(result);
          } else {
            console.error("Invalid rating:", product.avgRatings);
          }
        }
      });
      return data;
    }
  );
};
//////////////////////////////////////////////////////////////////

document.addEventListener("DOMContentLoaded", () => {
  const searchButton = document.querySelector(".mobile-search-bar__button");
  const searchInputSecond = document.querySelector(
    ".mobile-recommended-search__container .wizzy-search-input"
  );
  if (searchButton && searchInputSecond) {
    searchButton.addEventListener("click", () => {
      setTimeout(() => {
        searchInputSecond.click();
        searchInputSecond.focus();
      }, 900);
    });
  } else {
    console.warn("Button or input field not found.");
  }

  const searchButtonTwo = document.querySelector(
    ".mobile-menu__link.mobile-search-bar__button"
  );
  if (searchButtonTwo && searchInputSecond) {
    searchButtonTwo.addEventListener("click", () => {
      setTimeout(() => {
        searchInputSecond.click();
        searchInputSecond.focus();
      }, 900);
    });
  }
});
